export const setCookie = (name, expireInDays = 365) => {
  const d = new Date();
  d.setDate(d.getDate() + expireInDays);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=true;${expires};secure;`;
};

export const doesCookieExist = (name) => document.cookie.includes(name);
